import { render, staticRenderFns } from "./message_scroll.vue?vue&type=template&id=f1698ade&"
import script from "./message_scroll.vue?vue&type=script&lang=ts&"
export * from "./message_scroll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports